exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  position: absolute;\n  z-index: 200;\n  right: 8vw;\n  top: 3vw;\n}\nul.link-black a {\n  color: #000;\n}\nul.link-black a:before {\n  background: #000;\n}\nul a {\n  display: inline-block;\n  margin-left: 20px;\n  color: #fff;\n  cursor: pointer;\n  position: relative;\n  transition: color 1s ease-out;\n  will-change: color;\n}\nul a:before {\n  background: #fcfdff;\n  content: '';\n  display: block;\n  position: absolute;\n  top: -8px;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  -webkit-transform: scaleX(0);\n          transform: scaleX(0);\n  -webkit-transform-origin: 100% 0;\n          transform-origin: 100% 0;\n  transition: -webkit-transform 0.4s cubic-bezier(0.4, 0, 0.6, 1);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.6, 1);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.6, 1), -webkit-transform 0.4s cubic-bezier(0.4, 0, 0.6, 1);\n  will-change: transform;\n}\nul a.active:before,\nul a:hover:before {\n  -webkit-transform: scaleX(1);\n          transform: scaleX(1);\n  -webkit-transform-origin: 0% 0;\n          transform-origin: 0% 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/menu/menu.component.less
// module id = ../../../../../src/app/menu/menu.component.less
// module chunks = main